<script>
    let a;
    
    // 1 => config
    // 2 => countdown
    // 3 => congratz
    // 4 => erreur
    // 10 => work
    // 15 => rest
    let status = 1;

    let nbCycle = 5;
    let timeWork = 30;
    let timePreparation = 3;
    let timeLeft = 0;
    let currentRep = 0;
    let countdownState = "";
    let currentExo = {};

    $: timeLeftFormatted = ('0' + timeLeft).slice(-2);
    $: currentCycle = Math.ceil(currentRep /8);
    $: nbRep = nbCycle * 4 * 2;
    $: currentExoZeroIndex = Math.round(currentRep / 2);
    $: currentExoOneIndex = Math.round(currentRep / 2) + 1;

    function shuffle(a) {
		for (let i = a.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[a[i], a[j]] = [a[j], a[i]];
		}

		return a;
	}

	function getRandomExercices(arr, number){
		shuffle(arr);
		return arr.slice(0,number);
	}

    function getExercices(catalog, nbCycle){
		let selectedLegs = getRandomExercices(catalog.exercices.legs, nbCycle);
		let selectedArms = getRandomExercices(catalog.exercices.arms, nbCycle);
		let selectedAbs = getRandomExercices(catalog.exercices.abs, nbCycle);
		let selectedPlanks = getRandomExercices(catalog.exercices.planks, nbCycle);
		return [selectedLegs,selectedArms, selectedAbs, selectedPlanks];
	}

    function startCardeyClick(){
        status = 2;
        a = new AudioContext();
		
		timeLeft = timePreparation;
        countdownState = "Préparation";

        let data = sessionStorage.getItem('catalog');
        let catalog = JSON.parse(data);
        let exercices = getExercices(catalog, nbCycle);
        currentExo = exercices[0].shift();

        let timerInterval = setInterval(() => {
			timeLeft--;

			if( timeLeft == 0){
				beep2(50, 500, 30);
				clearInterval(timerInterval);
				startCountdown(timeWork, exercices);
			}
		}, 1000);
    }

    function startCountdown(timelimit, exercices) {
		beep2(50, 500, 30);
		
		timeLeft = timelimit;
		currentRep++;

		if( currentRep % 2 == 0) {
			countdownState = " - REPOS";
            status = 15;
            let mod = currentExoZeroIndex % 4;
            currentExo = exercices[mod].shift();
		} 
		else {
            countdownState = " - TRAVAIL";
            status = 10;
		}

		var timerInterval = setInterval(() => {
            timeLeft--;
            
            if( status === 15 && ( timeLeft == 1 || timeLeft == 2 || timeLeft == 0) ){
				beep2(50, 500, 30);
            }

			if( timeLeft == 0){
				beep2(50, 500, 30);
				clearInterval(timerInterval);
				
				if( currentRep < nbRep - 1){
					startCountdown(timelimit, exercices);
				}
				else{
                    status = 3;
				}
			}
		}, 1000);
    }
    
    function beep2(vol, freq, duration){
		// window.navigator.vibrate(200);

		var v=a.createOscillator()
		var u=a.createGain()
		v.connect(u)
		v.frequency.value=freq
		v.type="square"
		u.connect(a.destination)
		u.gain.value=vol*0.01
		v.start(a.currentTime)
		v.stop(a.currentTime+duration*0.01)
	}
</script>
<section id="content" 
        class:work="{status === 10}" 
        class:rest="{status === 15}" 
        class:congrats="{status === 3}"
        class:home="{status === 1}">
    <div id="config" class="centercontent" class:hidden="{status !== 1}" >
        <p>Préparation</p>
        <p>
            <label for="nbCycle"># cycle (1-8):</label>	
            <input type="number" id="nbCycle" name="nbCycle" min="1" max="8" bind:value={nbCycle}>
        </p>
        <p class="hidden">
            <label for="timeWork">temps de travail (15-45s):</label>	
            <input type="number" id="timeWork" name="timeWork" min="2" max="45" value="30">
        </p>
        <button name="btnCountdownStart" id="btnCountdownStart" class="btn-green" on:click={startCardeyClick} >Démarrer</button>
        <p>
            <img class="responsive" src="./img/cardey-cycle-min.png" alt="Cardey - schéma"/>
        </p>
    </div>

    <div id="countdown" class:hidden="{! [2,10,15].includes(status)}">
        <h2 id="countdownState">Cycle {currentCycle} - exo {currentExoZeroIndex} {countdownState}</h2>
        <div id="clockdiv">
            <div id="clockdivinner" class:workinner="{status === 10}" class:restinner="{[2,15].includes(status)}"  >
                <span id="seconds">{timeLeftFormatted}</span>
                <div class="smalltext">seconds</div>
            </div>
        </div>
        <h3 id="countdownExercice">{currentExo.name}</h3>
    </div>

    <div id="completed" class="centercontent" class:hidden="{status !== 3}">
        <h3>Félicitations !</h3>
    </div>

    <div id="error" class:hidden="{status !== 4}">
        Erreur :'(
    </div>
</section>

<style>
#content {
  width: 100%;
  position: absolute;
  top:50px;
  bottom: 0px;
  overflow: auto;
}

.responsive {
  max-width: 100%;
  height: auto;
}

.btn-green {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 3vw;
  border-radius: 3px;
}
.btn-green:hover {
	background-color:rgb(53, 161, 56);
}
.btn-green:active {
	position:relative;
	top:1px;
}

.workinner {background-color: red;}
.restinner {background-color: blue;}

.centercontent, #countdown {
    text-align: center;
    font-family: sans-serif;
    font-weight: 100;}

#clockdiv{
    font-family: sans-serif;
    color: #fff;
    display: inline-block;
    font-weight: 100;
    text-align: center;
    font-size: 13vw;
}

#clockdiv > div{
    padding: 10px;
    border-radius: 3px;
    /* background: #00BF96; */
    display: inline-block;
}

#clockdiv div > span{
    padding: 15px;
    border-radius: 3px;
    /* background: #00816A; */
    display: inline-block;
}

.smalltext{
    padding-top: 5px;
    font-size: 16px;
}
	
</style>